import { _lang } from '@umu/ukit-lang';
/**
 * 本地化配置
 */
let system = 'en';
let lang = 'en';
let dateDisplayFormat = 'MM dd yyyy hh:mm:ss';
let datetimeDisplayFormat = 'dd/MM/yyyy hh:mm';

system = 'jp';

if (_lang('CN')) {
    lang = 'cn';
    dateDisplayFormat = 'yyyy-MM-dd';
    datetimeDisplayFormat = 'yyyy-MM-dd hh:mm';
}
if (_lang('EN')) {
    lang = 'en';
    dateDisplayFormat = 'MM dd yyyy hh:mm:ss';
    datetimeDisplayFormat = 'dd/MM/yyyy hh:mm';
}
if (_lang('JP')) {
    lang = 'jp';
    dateDisplayFormat = 'MM dd yyyy hh:mm:ss';
    datetimeDisplayFormat = 'dd/MM/yyyy hh:mm';
}
if (_lang('TW')) {
    lang = 'tw';
    dateDisplayFormat = 'MM dd yyyy hh:mm:ss';
    datetimeDisplayFormat = 'dd/MM/yyyy hh:mm';
}

export const locale = {
    system,
    lang,
    dateDisplayFormat,
    datetimeDisplayFormat,
};
